import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { localizer } from 'utils/localizer';
import { CustomForm, CustomInput, CustomButton } from 'modules/form';
import SHA512 from 'crypto-js/sha512';
import { signUp } from './SignUpActions';

import './SignUpForm.css';

class SignUpForm extends CustomForm {
    constructor(props) {
        super(props);
    }
    onSubmitHandler = () => {
        if (this.isFormValid()) {
            const form = this.serializeForm();
            form.password = SHA512(form.password).toString();
            signUp(form);
        }
    };

    render() {
        return (
            <div className="sign-up-form">
                <p>
                    Thank you! You are just seconds away from creating your own
                    lease quotes. All we will need is your email address so that
                    your quote is unique to you
                </p>
                <br />
                <CustomInput
                    name="email"
                    type="email"
                    label="Email Address"
                    form={this}
                />
                <CustomInput
                    type="password"
                    label="Create Password (Must be 8 characters)"
                    name="password"
                    required
                    form={this}
                />
                {/* TODO: Make this a component */}
                <div className="radio-buttons">
                    <div className="radio-button">
                        <input
                            type="radio"
                            name="role"
                            value="vendor"
                            onChange={this.handleOnChange}
                        />
                        <label for="contactChoice2">
                            I am an equipment supplier
                        </label>
                    </div>
                    <div className="radio-button">
                        <input
                            type="radio"
                            name="role"
                            value="end-user"
                            onChange={this.handleOnChange}
                        />
                        <label for="contactChoice3">
                            My company will acquire equipment for our own use
                        </label>
                    </div>
                </div>
                <CustomButton
                    type="primary-button"
                    action={this.onSubmitHandler}
                    label={localizer.LOGIN_BTN_SIGN_UP}
                    loading={this.props.signUpState.loading}
                />
                <div class="link">
                    <Link to="login">Existing User Sign In</Link>
                </div>
            </div>
        );
    }
}

export default SignUpForm;



// WEBPACK FOOTER //
// ./src/modules/onboarding/pages/signup/SignUpForm.jsx